export {default} from './UserDetailModel';
export {UserDetailModelType} from './UserDetailModel';



// WEBPACK FOOTER //
// ./src/models/UserDetailModel/index.ts